import { styled } from '@linaria/react';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import SubTitleSkeleton from '@fe-news/components/atoms/PopTopic/SubTitleSkeleton';
import RelativeNewsCardSkeleton from '@fe-news/components/molecules/RelativeNewsCard/RelativeNewsCardSkeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 0px 16px 24px 16px;
  position: relative;
`;

const Button = styled.div`
  position: absolute;
  top: -45px;
  z-index: 1;
  right: 16px;
  cursor: pointer;
`;

const TagWrapper = styled.div`
  display: flex;
  column-gap: 12px;
`;

const PopTopicCardContentSkeleton = () => {
  return (
    <Container>
      <Button>
        <RectangleSkeleton width={78} height={36} />
      </Button>
      <RelativeNewsCardSkeleton>
        <SubTitleSkeleton />
      </RelativeNewsCardSkeleton>
      <div>
        <SubTitleSkeleton isNeedReadMore={false} />
        <TagWrapper>
          {Array.from({ length: 3 }).map((_, index) => (
            <RectangleSkeleton key={index} width={44} height={24} />
          ))}
        </TagWrapper>
      </div>
    </Container>
  );
};

export default PopTopicCardContentSkeleton;
